export default "__VITE_ASSET__CFJOA9sB__"